import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import ProjectCard from "./ProjectCard";
import { Link } from "react-router-dom";
import { API_ORIGIN } from "../config/api";
import { apiCall, getOptimizedImageUrl } from "../config/api";

// Helper slugify local
const slugify = (value = "") =>
  value
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");



// Récupère les projets "homepage" (tolérant aux alias)
const fetchHomepageProjects = async () => {
const data = await apiCall("/projects");
  const allProjects = data?.data ? Object.values(data.data) : [];
  const homepageProjects = allProjects.filter((p) => {
    const flag =
      p.isHomepageProject ?? p.isHomepage ?? p.homepage ?? p.isHome ?? false;
    return flag === true || flag === "true" || flag === 1 || flag === "1";
  });
  return homepageProjects.length
    ? homepageProjects
    : allProjects.slice(0, Math.min(7, allProjects.length));
};
function Header() {
  const carouselRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isAutoplaying, setIsAutoplaying] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [homepageProjects, setHomepageProjects] = useState([]);
  // swipe state
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [isSwiping, setIsSwiping] = useState(false);
  // load projects
 // load projects avec auto-refresh
useEffect(() => {
  const loadProjects = async () => {
    try {
      setLoading(true);
      setError(null);
      const projects = await fetchHomepageProjects();
      setHomepageProjects(projects);
      if (!projects.length) setError("Aucun projet marqué pour la page d'accueil");
    } catch (err) {
      setError(`Erreur de connexion: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  loadProjects();
  
  // ✅ Recharger toutes les 5 secondes pour voir les changements du toggle
  const interval = setInterval(loadProjects, 500000);
  
  return () => clearInterval(interval);
}, []);
  // mobile flag
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);
  // mapping pour le carrousel
 const projects = useMemo(() => {
 return homepageProjects.map((project, index) => {
  const rawImageUrl = project.previewImage || project.heroImage || "";
  const optimized = getOptimizedImageUrl(rawImageUrl);

  const safeSlug =
    project.slug ||
    (project.id ? slugify(project.id) : slugify(project.titre || `projet-${index}`));

  return {
    label: project.titre,
    slug: safeSlug,
    img: optimized,
    type: project.badges?.[0]?.toLowerCase() || project.badge?.toLowerCase() || "autre",
    badge: project.badge || project.badges?.[0] || "",
    description: project.sousTitre,
    fullProject: project,
  };
});

}, [homepageProjects]);
  // couleurs d’ombre (optionnel : garde ta logique si tu l’utilises)
  const [shadowColors, setShadowColors] = useState({});
  const extractDominantColor = useCallback((imageUrl, cb) => {
    if (!imageUrl) return cb("rgba(0,0,0,0.2)");
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      try {
        const c = document.createElement("canvas");
        const ctx = c.getContext("2d");
        c.width = img.width;
        c.height = img.height;
        ctx.drawImage(img, 0, 0);
        const samples = [
          ctx.getImageData(img.width * 0.5, img.height * 0.5, 1, 1).data,
          ctx.getImageData(img.width * 0.3, img.height * 0.3, 1, 1).data,
          ctx.getImageData(img.width * 0.7, img.height * 0.7, 1, 1).data,
        ];
        let r = 0,
          g = 0,
          b = 0;
        samples.forEach((s) => {
          r += s[0];
          g += s[1];
          b += s[2];
        });
        r = Math.floor((r / samples.length) * 0.7);
        g = Math.floor((g / samples.length) * 0.7);
        b = Math.floor((b / samples.length) * 0.7);
        cb(`rgba(${r}, ${g}, ${b}, 0.3)`);
      } catch {
        cb("rgba(0,0,0,0.2)");
      }
    };
    img.onerror = () => cb("rgba(0,0,0,0.2)");
    img.src = imageUrl;
  }, []);
  useEffect(() => {
    if (!projects.length) return;
    const next = {};
    let done = 0;
    projects.forEach((p, i) => {
      extractDominantColor(p.img, (color) => {
        next[i] = color;
        done++;
        if (done === projects.length) setShadowColors(next);
      });
    });
  }, [projects, extractDominantColor]);
  useEffect(() => {
    projects.forEach((_, i) => {
      const el = document.querySelector(`.carousel-item:nth-child(${i + 1})`);
      if (el && shadowColors[i]) {
        el.style.setProperty("--shadow-color", shadowColors[i]);
      }
    });
  }, [shadowColors, projects, activeIndex]);
  /* -------------- Carrousel -------------- */
  const getSlidePosition = (index) => {
    if (!projects.length) return { className: "carousel-item hidden" };
    let relative = index - activeIndex;
    // boucle infinie
    if (relative < -Math.floor(projects.length / 2)) relative += projects.length;
    else if (relative > Math.floor(projects.length / 2)) relative -= projects.length;
    const isSmall = window.innerWidth <= 768;
    if (relative === 0) return { className: "carousel-item active" };
    if (relative === -1 || (activeIndex === 0 && index === projects.length - 1))
      return { className: "carousel-item prev" };
    if (relative === 1 || (activeIndex === projects.length - 1 && index === 0))
      return { className: "carousel-item next" };
    if (relative === -2 || (relative === projects.length - 2 && projects.length > 3))
      return { className: isSmall ? "carousel-item hidden" : "carousel-item prev-hidden" };
    if (relative === 2 || (relative === -(projects.length - 2) && projects.length > 3))
      return { className: isSmall ? "carousel-item hidden" : "carousel-item next-hidden" };
    if (relative === -3 || (relative === projects.length - 3 && projects.length > 5))
      return { className: isSmall ? "carousel-item hidden" : "carousel-item far-prev" };
    if (relative === 3 || (relative === -(projects.length - 3) && projects.length > 5))
      return { className: isSmall ? "carousel-item hidden" : "carousel-item far-next" };
    return { className: "carousel-item hidden" };
  };
  const goToSlide = useCallback(
    (idx) => {
      if (isAnimating || !projects.length) return;
      setIsAnimating(true);
      let next = idx;
      if (next < 0) next = projects.length - 1;
      if (next >= projects.length) next = 0;
      setActiveIndex(next);
      setTimeout(() => setIsAnimating(false), isMobile ? 300 : 600);
    },
    [isAnimating, isMobile, projects.length]
  );
  const nextSlide = useCallback(() => goToSlide(activeIndex + 1), [goToSlide, activeIndex]);
  const prevSlide = useCallback(() => goToSlide(activeIndex - 1), [goToSlide, activeIndex]);
  // 🔁 même comportement partout : clic carte latérale ⇒ centre
  const handleCardClick = useCallback(
    (e, targetIndex) => {
      if (targetIndex !== activeIndex) {
        e.preventDefault();
        if (isAutoplaying) setIsAutoplaying(false);
        goToSlide(targetIndex);
        return;
      }
      // si carte centrale → navigation normale
    },
    [activeIndex, isAutoplaying, goToSlide]
  );
  // drag / swipe
  useEffect(() => {
    let startX = 0;
    let startY = 0;
    let inZone = false;
    const onStart = (e) => {
      const el = carouselRef.current;
      if (!el) return;

      // En desktop, vérifier si on clique sur la carte active
      if (window.innerWidth > 768) {
        const target = e.target;
        const activeCard = target.closest('.project-card.is-active');
        // Si on clique sur la carte active, ne pas activer le swipe
        if (activeCard) {
          return;
        }
      }

      const rect = el.getBoundingClientRect();
      const t = e.touches ? e.touches[0] : e;
      if (t.clientX >= rect.left && t.clientX <= rect.right && t.clientY >= rect.top && t.clientY <= rect.bottom) {
        inZone = true;
        startX = t.clientX;
        startY = t.clientY;
        if (isAutoplaying) setIsAutoplaying(false);
        setIsSwiping(true);
        if (!e.touches) setIsMouseDown(true);
      }
    };
    const onMove = (e) => {
      if (!inZone) return;
      const t = e.touches ? e.touches[0] : e;
      const dx = Math.abs(t.clientX - startX);
      const dy = Math.abs(t.clientY - startY);
      if (e.touches && dx > dy && dx > 10) e.preventDefault();
    };
    const onEnd = (e) => {
      if (!inZone) return;
      const t = e.changedTouches ? e.changedTouches[0] : e;
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      const threshold = 50;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > threshold) {
        if (dx > 0) prevSlide();
        else nextSlide();
      }
      inZone = false;
      startX = startY = 0;
      setIsSwiping(false);
      setIsMouseDown(false);
    };
    document.addEventListener("touchstart", onStart, { passive: false });
    document.addEventListener("touchmove", onMove, { passive: false });
    document.addEventListener("touchend", onEnd, { passive: false });
    document.addEventListener("mousedown", onStart);
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onEnd);
    return () => {
      document.removeEventListener("touchstart", onStart);
      document.removeEventListener("touchmove", onMove);
      document.removeEventListener("touchend", onEnd);
      document.removeEventListener("mousedown", onStart);
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onEnd);
    };
  }, [isAutoplaying, nextSlide, prevSlide]);
  // autoplay
  useEffect(() => {
    if (!isAutoplaying) return;
    const id = setInterval(() => {
      if (!isAnimating && !isMouseDown && !isSwiping) nextSlide();
    }, isMobile ? 6000 : 8000);
    return () => clearInterval(id);
  }, [isAutoplaying, isMobile, nextSlide, isAnimating, isMouseDown, isSwiping]);
  /* -------------- Rendering -------------- */
  if (loading) {
    return (
      <section className="realisation-page home-section home-section--flush-inline">
        <div className="header-fixed-content">
          <h1 className="main-title">Capturer l'âme.</h1>
          <p className="main-subtitle">Chargement des projets...</p>
        </div>
        <div className="carousel-container">
          <div className="carousel-loading">
            <div className="loading-spinner">
              <div className="spinner"></div>
            </div>
          </div>
        </div>
      </section>
    );
  }
  if (error) {
    return (
      <section className="realisation-page home-section home-section--flush-inline">
        <div className="header-fixed-content">
          <h1 className="main-title">Capturer l'âme.</h1>
          <p className="main-subtitle">Erreur de chargement</p>
        </div>
        <div className="carousel-container">
          <div className="carousel-error">
            <p>{error}</p>
            <button onClick={() => window.location.reload()}>Réessayer</button>
          </div>
        </div>
      </section>
    );
  }
  if (!projects.length) {
    return (
      <section className="realisation-page home-section home-section--flush-inline">
        <div className="header-fixed-content">
          <h1 className="main-title">Capturer l'âme.</h1>
          <p className="main-subtitle">Aucun projet disponible</p>
        </div>
        <div className="carousel-container">
          <div className="carousel-error">
            <p>Aucun projet configuré pour la page d'accueil</p>
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="realisation-page home-section home-section--flush-inline">
      <div className="header-fixed-content">
        <h1 className="main-title">Capturer l'âme.</h1>
        <p className="main-subtitle">Capturez les moments inoubliables</p>
      </div>
      <div className="carousel-container">
        <div
          className="carousel"
          ref={carouselRef}
          style={{
            touchAction: "pan-y",
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
            cursor: isMouseDown ? "grabbing" : "grab",
          }}
        >
          {projects.map((project, index) => {
            const { className } = getSlidePosition(index);
            // 7 cartes sur desktop, 5 max tablette, 3 max mobile
            if (
              className.includes("hidden") &&
              !className.includes("prev-hidden") &&
              !className.includes("next-hidden") &&
              !className.includes("far-prev") &&
              !className.includes("far-next")
            ) {
              return null;
            }
            if (
              window.innerWidth <= 420 &&
              (className.includes("prev-hidden") ||
                className.includes("next-hidden") ||
                className.includes("far-prev") ||
                className.includes("far-next"))
            ) {
              return null;
            }
           
            return (
              <div
                key={index}
                className={className}
                style={{ "--shadow-color": shadowColors[index] || "rgba(0,0,0,0.3)" }}
              >
                <ProjectCard
                  label={project.label}
                  img={project.img}
                  slug={project.slug}
                  type={project.type}
                  badge={project.badge}
                  description={project.description}
                  onClick={(e) => handleCardClick(e, index)}
                  isActive={index === activeIndex}
                />
              </div>
            );
          })}
        </div>
        <button className="carousel-control prev" onClick={prevSlide} aria-label="Précédent">
          <span>&#10094;</span>
        </button>
        <button className="carousel-control next" onClick={nextSlide} aria-label="Suivant">
          <span>&#10095;</span>
        </button>
       
        <div className="carousel-discover">
          <Link to="/realisations" className="carousel-discover__button">
            Decouvrir mes series
          </Link>
        </div>
        <div className="carousel-indicators">
          {projects.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === activeIndex ? "active" : ""}`}
              onClick={() => goToSlide(index)}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
export default Header;
